<template>
	<v-app id="k4dashboard">
		<layout-error-boundary class="fill-wh" :on-error="handleAuthError">
			<component :is="layout" v-if="layout">
				<router-view />
			</component>
			<router-view v-else />
		</layout-error-boundary>
	</v-app>
</template>

<script>
import { APIAuthError } from "@/utils/http";

// Import our main stylesheet
import "@/sass/main.scss";

export default {
	computed: {
		layout() {
			return this.$route.meta.layout;
		},
	},

	methods: {
		handleAuthError(err, vm, info) {
			// We only want to handle 40X errors. Keep propagating any others.
			if (!(err instanceof APIAuthError)) return true;

			console.debug("Captured 40X error: Redirecting to login page...");

			// We've captured a 40X error that originated somewhere in a
			// child component. Redirect to login page.
			this.$router.push({
				name: "Login",
				query: { redirectFrom: this.$route.fullPath },
			});

			// Prevent further propagation of error.
			return false;
		},
	},
};
</script>
